var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAirConditioning = function SvgAirConditioning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 18.521 21.2"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "m6.76 2.1 2.5 1.5m0 0 2.5-1.5m-2.5 1.5v-3m0 3v7m-2.5 8.5 2.5-1.5m0 0 2.5 1.5m-2.5-1.5v3m0-3v-7M.65 8.515 3.197 7.1m0 0L3.15 4.185M3.2 7.1.6 5.6m2.598 1.5 6.063 3.5m6.11 6.415-.048-2.915m0 0 2.549-1.415m-2.55 1.415-6.061-3.5m6.062 3.5 2.598 1.5M3.149 17.015 3.2 14.1m0 0-2.55-1.415M3.2 14.1.6 15.6m2.598-1.5 6.063-3.5m8.61-2.085L15.324 7.1m0 0 .049-2.915m-.05 2.915-6.061 3.5m6.062-3.5 2.598-1.5"
  })));
};
export default SvgAirConditioning;